import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, IconButton, Avatar, Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const DoubleConfirmModal = ({
  open,
  message,
  confirmButtonText = 'Confirmar',
  cancelButtonText = 'Cancelar',
  handleConfirm,
  handleCancel,
}) => {
  return (
    <Dialog
      open={open}
      disableRestoreFocus
      onClose={handleCancel}                 // igual que antes: cierra con cancel
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          overflow: 'hidden',
          boxShadow: '0 12px 32px rgba(0,0,0,.18)',
        },
      }}
    >
      {/* Header temático azul */}
      <DialogTitle
        sx={{
          m: 0,
          px: 'clamp(14px, 1.8vw, 20px)',
          py: 'clamp(10px, 1.2vw, 14px)',
          display: 'flex',
          alignItems: 'center',
          gap: 1.2,
          background: 'linear-gradient(135deg, #0655A5 0%, #0861B8 100%)',
          color: '#ffffff',
        }}
      >
        <Avatar sx={{ width: 'clamp(24px, 2vw, 28px)', height: 'clamp(24px, 2vw, 28px)', bgcolor: 'white', color: '#0655A5' }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 'clamp(14px, 1.2vw, 18px)' }} />
        </Avatar>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 900,
            flex: 1,
            lineHeight: 1.2,
            fontSize: 'clamp(0.92rem, 0.88rem + 0.2vw, 1.05rem)',
            letterSpacing: '-0.01em'
          }}
        >
          Confirmación
        </Typography>
        <Tooltip title="Cerrar">
          <IconButton
            onClick={handleCancel}
            size="small"
            sx={{
              color: 'white',
              bgcolor: 'rgba(255,255,255,0.12)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      {/* Cuerpo */}
      <DialogContent sx={{ p: 'clamp(16px, 2vw, 22px)', bgcolor: '#ffffff' }}>
        <Typography
          sx={{
            textAlign: 'center',
            fontSize: 'clamp(0.82rem, 0.80rem + 0.1vw, 0.92rem)',
            color: '#334155',
            fontWeight: 600,
            py: 1
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      {/* Acciones */}
      <DialogActions
        sx={{
          px: 'clamp(14px, 1.8vw, 20px)',
          py: 'clamp(10px, 1.2vw, 14px)',
          bgcolor: '#f8fafc',
          borderTop: '1px solid #e2e8f0',
          justifyContent: 'flex-end',
          gap: 1.5,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleCancel}
          sx={{
            borderRadius: '8px',
            px: 'clamp(12px, 1.2vw, 16px)',
            py: 'clamp(4px, 0.5vw, 6px)',
            fontWeight: 700,
            fontSize: 'clamp(0.74rem, 0.72rem + 0.08vw, 0.82rem)',
            textTransform: 'none',
            borderColor: '#cbd5e1',
            color: '#64748b',
            '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
          }}
        >
          {cancelButtonText}
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          autoFocus
          sx={{
            borderRadius: '8px',
            px: 'clamp(14px, 1.5vw, 20px)',
            py: 'clamp(4px, 0.5vw, 6px)',
            fontWeight: 800,
            fontSize: 'clamp(0.74rem, 0.72rem + 0.08vw, 0.82rem)',
            textTransform: 'none',
            background: 'linear-gradient(135deg, #0655A5 0%, #0861B8 100%)',
            boxShadow: '0 3px 10px rgba(6, 85, 165, 0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, #054785 0%, #0655A5 100%)',
              boxShadow: '0 4px 14px rgba(6, 85, 165, 0.45)'
            }
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DoubleConfirmModal;